/**
 * Enumeration of all possible component states for the StateViewComponent.
 */
export var State;
(function (State) {
    State["Empty"] = "empty";
    State["Loading"] = "loading";
    State["Content"] = "content";
    State["Error"] = "error";
})(State || (State = {}));
/**
 * Merges the given collection of states into a single state. This function prioritizes the Error state (if at least
 * one constituent state is Error, then the merged state is Error), followed by Loading, followed by Content. The
 * Empty state is only used if all constituent states are Empty or undefined.
 * @param states {State} Individual constituent states to merge
 * @returns {State} Merged state
 */
export function mergeStates() {
    var states = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        states[_i] = arguments[_i];
    }
    if (states.some(function (s) { return s === State.Error; })) {
        return State.Error;
    }
    if (states.some(function (s) { return s === State.Loading; })) {
        return State.Loading;
    }
    if (states.some(function (s) { return s === State.Content; })) {
        return State.Content;
    }
    return State.Empty;
}
